<template>
  <div class="share-qr-code px-10">
    <div class="text-center">
      <div class="text-theme-black-650">
        <span>{{ shareText }}</span>
      </div>
      <div class="mt-8">
        <span class="text-theme-black-850">请用手机微信扫描下方二维码分享</span>
      </div>
      <div class="mt-2">
        <span class="text-theme-black-650">直接分享该二维码，将无法获得分享奖励</span>
      </div>
      <div class="mt-8">
        <vue-qr
          ref="qr"
          :logo-src="logoSrc"
          :text="url"
          :margin="10"
          :size="600"
          style="width: 200px; height: 200px"
          :logoScale="0.25"
        />
      </div>
    </div>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { getStatusConfig } from 'dygc'

export default {
  name: 'ShareQrCode',
  components: { VueQr },
  props: {
    url: String
  },
  data() {
    return {
      // logoSrc: require('@/assets/img/qrcode/logo.png')
      logoSrc: ''
    }
  },
  computed: {
    shareText() {
      return this.$answerUtil.getShareText(this.$bus)
    }
  },
  created() {
    console.log(this.url)
    // 答题换壳
    if(!this.$bus.params.companyid || this.$bus.params.companyid === "0") {
      this.logoSrc = require('@/assets/img/qrcode/logo.png')
      return
    }
    getStatusConfig(this.$bus.params.companyid, ["out_D71"]).then(res => {
      if(res?.code !== 0) return
      this.logoSrc = res.data.out_D71 || require('@/assets/img/qrcode/logo.png')
    })
  }
}
</script>
